import React from 'react';

const Close = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.6864 6.14282L12.0883 10.7419L7.4902 6.14282L6.14258 7.49044L10.7416 12.0885L6.14258 16.6866L7.4902 18.0343L12.0883 13.4352L16.6864 18.0343L18.034 16.6866L13.435 12.0885L18.034 7.49044L16.6864 6.14282Z",
      fill: "#A7A7A7"
    }
  )
);

export { Close };
//# sourceMappingURL=Close.js.map
